export default "__VITE_ASSET__E2Y58Tap__"